<template>
  <app-card
    class="p-6 flex flex-col"
    :status="
      project.collaboration_agreement_uploaded ? 'complete' : 'incomplete'
    "
  >
    <div>
      <app-badge
        v-if="project.collaboration_agreement_uploaded"
        type="positive"
        icon="check"
      >
        Uploaded
      </app-badge>
      <app-badge
        v-else
        type="neutral"
        icon="important"
      >
        Required
      </app-badge>
      <h2 class="text-lg mb-1">
        {{ project.ref }} Collaboration Agreement
      </h2>
    </div>
    <div class="text-grey-700 text-sm mb-6">
      <p
        v-if="!project.collaboration_agreement_uploaded"
        class="text-neutral-800 mb-2"
      >
        <b>Please upload your collaboration agreement</b>
      </p>
      <p><b>Collaborators:</b></p>
      <p
        v-for="partner in partners"
        :key="partner.id"
      >
        {{ partner.company.name }}
      </p>
    </div>
    <input
      v-if="
        !project.collaboration_agreement_uploaded &&
          authUser.isLead &&
          authUser.isEditor
      "
      ref="upload"
      class="sr-only"
      type="file"
      accept=".pdf,.docx,.doc,.xlsx,.xls,.zip,.ppt,pptx"
      :disabled="loading"
      @input="uploadCollaborationAgreement"
    />
    <div class="border-t pt-4 mt-auto flex items-center">
      <p
        v-if="loading"
        class="text-primary-500 italic text-sm"
      >
        Uploading collaboration agreement...
      </p>
      <icon-link
        v-if="project.collaboration_agreement_uploaded"
        :href="
          route('applications.files.download', {
            application: project.uuid,
            file: project.collaboration_agreement.id
          }) + '?project=1'
        "
        class="ml-auto"
        icon="cheveron-down-circle"
        icon-placement="right"
        target="_blank"
      >
        Download
      </icon-link>
      <icon-link
        v-else-if="authUser.isLead && authUser.isEditor"
        href="#"
        class="ml-auto"
        icon="arrow-thick-up-circle"
        icon-placement="right"
        target="_blank"
        @click.prevent="focusUpload"
      >
        Upload Agreement
      </icon-link>
      <p
        v-else
        class="italic text-xs text-neutral-600"
      >
        The lead applicant's organisation is reponsible for uploading you
        collaboration agreement.
      </p>
    </div>
  </app-card>
</template>

<script>
export default {
  name: "UserCollaborationAgreementCard",
  props: {
    project: {
      type: Object,
      required: true
    },
    partners: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    authUser() {
      return window._user;
    }
  },
  methods: {
    focusUpload() {
      if (this.loading) return;
      return this.$refs.upload.click();
    },
    validFile(file) {
      const errors = [];

      if (file.size / 1024 / 1024 > 20)
        errors.push(`This file exceeds the upload limit of 5mb`);

      if (errors.length) {
        file["errors"] = errors;
      }
      return file;
    },
    uploadCollaborationAgreement() {
      const fileUpload = this.$refs.upload;
      const inputFiles = fileUpload.files;

      if (
        (!this.authUser.isLead && !this.authUser.isEditor) ||
        !inputFiles.length
      )
        return;

      let formData = new FormData();
      this.loading = true;

      formData.append("parent_key", "collaboration_agreement_upload");
      formData.append("key", "collaboration_agreement");
      formData.append("action", "collaboration_agreement_uploaded");

      let file = this.validFile(inputFiles[0]);
      if (file.hasOwnProperty("errors")) {
        alert(file.errors[0]);
        return;
      } else {
        formData.append(`collaboration_agreement[0]`, file);
      }

      axios
        .post(route("applications.upload", this.project.uuid), formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(({ data }) => {
          formData = null;
          fileUpload.setAttribute("files", null);
          fileUpload.setAttribute("value", "");
          Turbolinks.visit(window.location.toString(), { action: "replace" });
        })
        .catch(({ response, data }) => {
          window.alert("Unable to upload your file, please try again later.");
        });
    }
  }
};
</script>
